/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { ToastContent } from 'react-toastify';

interface ToastContextType {
  toastError: (content?: ToastContent) => void;
  toastSuccess: (content: ToastContent, autoClose?: number) => void;
  dismiss: (id?: number | undefined) => void;
}

const ToastContext = createContext<ToastContextType>({
  toastError: () => {},
  toastSuccess: () => {},
  dismiss: () => {},
});

export default ToastContext;
